import JSZip from 'jszip';
import FileSaver from 'file-saver';
import AppBlobCache from './AppBlobCache'
import GlobalStorage from './component_tbc_editor/storage/GlobalStorage';
import axios from 'axios' 

let instance = null;

export default class AppConnector
{
  constructor()
  {
    if (!instance) {
      instance = this;
    }

    instance.blobs = instance.blobs || {};
    return instance;
  }
  
  listStory(callback,page)
  {
    var GS = new GlobalStorage();

    axios({
      method: 'get',
      url: global.CMS_URL+'admin/stories/?pageNumber='+page+'&pageSize=11',      
      headers: {
        Authorization: GS.getUser().token 
      }
    }).then(response => {      
      GS.setUserStory(response.data.storyList.content);      
      GS.setTotalPages(response.data.storyList.totalPages);
      callback();
      //console.log(GS.getUserStory());
    })
    .catch(error => {        
      console.log(error)
    })


  }

  listStoryDetail(callback,uuid)
  {
    var GS = new GlobalStorage();
    var API =  global.API_URL.replace("v1","v2");
    axios({
      method: 'get',
      url: API+'stories/details/'+uuid,      
      headers: {
        Authorization: GS.getUser().token 
      }
    }).then(response => {      
      console.log(response.data);
      callback();      
    })
    .catch(error => {        
      console.log(error)
    })


  }

  listStoryEpisode(callback)
  {
    var GS = new GlobalStorage();

    axios({
      method: 'get',
      url: global.CMS_URL+'admin/stories/'+GS.getStory().uuid+'/episode/?pageNumber=1&pageSize=300',      
      headers: {
        Authorization: GS.getUser().token,
      }
    }).then(response => {      
      
      response.data.storyEpisodeList.content.sort(function (a, b) {
          return a.createAt.localeCompare(b.createAt);
      }).reverse();

      GS.setUserStoryEpisodeList(response.data);      
      if (global.DEBUG) console.log(GS.getUserEpisodeList());
      callback();

    })
    .catch(error => {        
      console.log(error)
    })


  }

  
  createStory(callback, uploadDefaultImage)
  {
    var GS = new GlobalStorage();                              
    console.log("////createStory");
   console.log(GS.getStory());
    let formData = new FormData();
    formData.append('uuid',GS.getStory().uuid);
    formData.append('storyName',GS.getStory().storyName);
    formData.append('author',GS.getStory().author);
    formData.append('description',GS.getStory().description);
    formData.append('channel',GS.getStory().channel);
  
    if (document.getElementById("story-cover-image") && document.getElementById("story-cover-image").files[0] !== undefined) {
      formData.append('coverImage', document.getElementById("story-cover-image").files[0]);
    }else{

      function dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
          byteString = atob(dataURI.split(',')[1]);
        else
          byteString = unescape(dataURI.split(',')[1]);
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
          ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ia], {type:mimeString});
      }
      
      
      var blob;
      switch (GS.getStory().category){
        case "ROMANCE":
          blob = dataURItoBlob(global.ROMANCE);
        break;
        case "SCIENCE_FICTION":
            blob = dataURItoBlob(global.SCIENCE_FICTION);
        break;
        case "MYSTERY":
            blob = dataURItoBlob(global.MYSTERY);
        break;
        case "COMEDY":
            blob = dataURItoBlob(global.COMEDY);
        break;
        case "HORROR":
            blob = dataURItoBlob(global.HORROR);
        break;
        case "CHINESE_MARTIAL":
            blob = dataURItoBlob(global.CHINESE_MARTIAL);
        break;

      

      }

      const file = new File([blob], "capture.jpg", {
          type: 'image/jpg'
      });
      if (uploadDefaultImage)
      formData.append('coverImage', file);
    }
    
   
    formData.append('shareUrl',"");
    formData.append('defaultShareUrl','true')

    var warningList = [...GS.getStory().warningList];

    //formData.append('warningList','['+warningList.toString()+']');
    formData.append('warningList',warningList.toString());
    //formData.append('additionalInfoList','[{%22label%22%20:%20%22Additional%20Info%22,%20%22url%22%20:%20%22Additional%20Info%20URL%22}]');
    formData.append('additionalInfoList','[]');
    formData.append('category',GS.getStory().category);
    
    
    
    
    formData.append('backOnCount','0');
    formData.append('type',GS.getStory().type);
    formData.append('stage',"RELEASE");
    formData.append('status',"ACTIVE");
    formData.append('suggested',GS.getStory().suggested);
    formData.append('storyEndingCTAMap','{"CONTINUING":{"cssId":"story-ending-cta-continuing-tab","label":"連載中 (Continuing)","to":"","sign":{},"message":[{"author":"","content":""}],"buttonList":[{"type":"COMMENT","action":""},{"type":"BOOKMARK","action":""},{"type":"SHARE","action":""}]},"TO_BE_CONTINUED":{"cssId":"story-ending-cta-to-be-continued-tab","label":"待續 (To Be Continued)","to":"","sign":{},"message":[{"author":"tbc...","content":"多謝觀看《人人故事》，記得幫手share！"}],"buttonList":[{"type":"COMMENT","action":""},{"type":"BOOKMARK","action":""},{"type":"SHARE","action":""}]},"ENDED":{"cssId":"story-ending-cta-ended-tab","label":"已完結 (Ended)","to":"","sign":{},"message":[{"author":"","content":""}],"buttonList":[{"type":"COMMENT","action":""},{"type":"SHARE","action":""},{"type":"BOOKMARK","action":""}]},"UPCOMING":{"cssId":"story-ending-cta-upcoming-tab","label":"集氣中 (Upcoming)","to":"","sign":{},"message":[{"author":"","content":""}],"buttonList":[{"type":"","action":""}]}}');
    //formData.append('enablePush',false);
if (global.DEBUG){
    for (var pair of formData.entries()) {
      console.log(pair[0]+ ', ' + pair[1]); 
    }
}


    axios({
      method: 'POST',
      url: global.CMS_URL+'admin/stories/'+GS.getStory().uuid,
      data: formData,
      headers: {
        Authorization: GS.getUser().token 
      }
    })
    .then(response => {
      GS.getStory().uuid = response.data;
      if (global.DEBUG) console.log(GS.getStory().uuid);      
      this.listStory(callback,1);    
    })
    .catch(error => {        
      console.log(error)
    })
    
  }

  updateStoryEpisode(callback){
    var GS = new GlobalStorage();                              
    let formData = new FormData()


    var storyUuid=GS.getStory().uuid;
    
    
    if (GS.getStoryEpisode().coverImage) {
      formData.append('image', GS.getStoryEpisode().coverImage)
    }
    
    var URL_params={      
      storyUuid:storyUuid,
      episodeUuid:GS.getStoryEpisode().uuid,
      title:GS.getStoryEpisode().project_name,
      sequence:GS.getStoryEpisode().sequence,
      freePreview:GS.getStoryEpisode().freePreview,
      order:GS.getStoryEpisode().order,
      publishState:"PUBLISHED",
      enablePush:false,
      publishAt:new Date().toISOString().split('.')[0]+"Z"
    }

    /*formData.append('storyUuid', storyUuid)
    formData.append('episodeUuid', GS.getStoryEpisode().uuid)
    formData.append('title', GS.getStoryEpisode().project_name)
    formData.append('sequence', GS.getStoryEpisode().sequence)
    //formData.append('publishState', "PUBLISHED")
    formData.append('enablePush', false)
    //formData.append('publishAt', new Date().toISOString().split('.')[0]+"Z")
*/
    if (global.DEBUG) {
      console.log(URL_params);
      document.getElementById("demo").innerHTML = JSON.stringify(
        {
          method: 'post',
          url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/'+GS.getStoryEpisode().uuid,
          data: formData,
          params:URL_params,
          headers: {
            Authorization: GS.getUser().token
          }
        } 
      );
      
    }
    axios({
      method: 'post',
      url: global.CMS_URL+'admin/stories/' + storyUuid + '/episode/'+GS.getStoryEpisode().uuid,
      data: formData,
      params:URL_params,
      headers: {
        Authorization: GS.getUser().token
      }
    })
    .then(response => {
      console.log(response);
      callback(response.data);      
    })
    .catch(error => {        
      console.log(error)
    })
  }


  deleteStory(uuid,callback,page)
  {
    var GS = new GlobalStorage();                              
   
    let formData = new FormData();
    formData.append('uuid',uuid);
    axios({
      method: 'DELETE',
      url: global.CMS_URL+'admin/stories/'+uuid,
      data: formData,
      headers: {
        Authorization: GS.getUser().token 
      }
    })
    .then(response => {
      this.listStory(callback,page);    
      
    })
    .catch(error => {        
      console.log(error)
    })
    
  }

  deleteStoryEpisode(uuid,callback)
  {
    var GS = new GlobalStorage();                              
   
    let formData = new FormData();
    formData.append('uuid',uuid);
    axios({
      method: 'DELETE',
      url: global.CMS_URL+'admin/stories/'+GS.getStory().uuid+'/episode/'+uuid,
      data: formData,
      headers: {
        Authorization: GS.getUser().token 
      }
    })
    .then(response => {
      this.listStoryEpisode(callback);          
    })
    .catch(error => {        
      console.log(error)
    })    
  }
  

  
  
}
